import React from "react";
import { Link } from "react-router-dom";
import AfrocentecLogo from "../../images/afrocentec_logo.png";
import Katundu360Logo from "../../images/logo.png"; // Add this import

const Footer = ({ tenant_info }) => {
  return (
    <div className="nk-footer">
      <div className="container-fluid">
        <div className="nk-footer-wrap d-flex flex-wrap justify-content-between align-items-center">
          <div className="nk-footer-copyright">
            © {new Date().getFullYear()}{" "}
            <a href="#">{`${tenant_info?.name}. All Rights Reserved.`}</a>
          </div>
          <div className="nk-footer-links">
            <ul className="nav nav-sm align-items-center">
              <li className="nav-item">
                <Link to={`${process.env.PUBLIC_URL}/pages/terms-policy`} className="nav-link">
                  Terms
                </Link>
              </li>
              <li className="nav-item">
                <Link to={`${process.env.PUBLIC_URL}/pages/faq`} className="nav-link">
                  Privacy
                </Link>
              </li>
              <li className="nav-item">
                <Link to={`${process.env.PUBLIC_URL}/pages/terms-policy`} className="nav-link">
                  Help
                </Link>
              </li>
              <li className="nav-item">
                <div className="d-flex align-items-center gap-3 ms-2">
                  <div className="d-flex align-items-center gap-2">
                    <span>Powered by</span>
                    <img
                      src={Katundu360Logo}
                      alt="Katundu360"
                      style={{ height: "24px", objectFit: "contain" }}
                    />
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <span>Developed by</span>
                    <a href="https://afrocentec.com" target="_blank" rel="noopener noreferrer">
                      <img
                        src={AfrocentecLogo}
                        alt="Afrocentec"
                        style={{ height: "24px", objectFit: "contain" }}
                      />
                    </a>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
